import { extractDate } from "./helpers";

export const vendorInfoFields = [
  {
    label: "Vendor Corp Name",
    name: "vendorCorpName",
    key: "vendorCorpName",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string"],
  },
  {
    label: "Duns #",
    name: "duns",
    key: "duns",
    disabled: true,
    fieldType: "text",
    type: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Dept #",
    name: "dept",
    key: "dept",
    disabled: false,
    fieldType: "select",
    isRequired: "required",
    options: [],
    validation: ["string"],
  },
  {
    label: "Ven #",
    name: "actualVendorNumber",
    key: "actualVendorNumber",
    disabled: true,
    fieldType: "text",
    type: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Operating Division",
    name: "sellingChannel",
    key: "sellingChannel",
    disabled: true,
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Vendor Connection",
    name: "vendorConnectionPlatform",
    key: "vendorConnectionPlatform",
    disabled: false,
    fieldType: "select",
    options: [
      {
        label: "Commerce Hub",
        value: "chub",
      },
      {
        label: "Direct EDI",
        value: "directEdi",
      },
      {
        label: "Direct EDI RDS",
        value: "directEdiRDS",
      },
    ],
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string", "VDF"],
  },
  {
    label: "Target Live Date",
    name: "goLiveTarget",
    key: "goLiveTarget",
    disabled: false,
    fieldType: "date",
    isRequired: "required",
    cb: (date) => extractDate(date),
    validation: ["string"],
  },
  {
    label: "Pipeline Ownership",
    name: "plOwnerShipName",
    key: "plOwnerShipName",
    disabled: false,
    fieldType: "select",
    isRequired: "required",
    options: [],
    // validation: ["required", "alpha_space"],
    validation: ["string"],
  },
  {
    label: "Additional DVN(s)",
    name: "additionalDVN",
    key: "additionalDVN",
    disabled: true,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Product Type",
    name: "productGrp",
    key: "productGrp",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string"],
    maxLength: 30,
  },
  {
    label: "Annual Sales Volume",
    name: "salesProjections",
    key: "salesProjections",
    disabled: false,
    fieldType: "USDNumber",
    isRequired: "required",
    validation: ["string", "numeric"],
    maxLength: 15,
  },
  {
    label: "Macy's Agreement Date",
    name: "macysAgreementDate",
    key: "macysAgreementDate",
    disabled: false,
    fieldType: "date",
    isRequired: "required",
    cb: (date) => extractDate(date),
    validation: ["string"],
  },
  {
    label: "CHUB Agreement Date",
    name: "chubAgreementDate",
    key: "chubAgreementDate",
    disabled: false,
    fieldType: "date",
    isRequired: "required",
    cb: (date) => extractDate(date),
    validation: ["string"],
  },
  {
    label: "CHUB Integration Profile",
    name: "chubIntegrationProfile",
    key: "chubIntegrationProfile",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string"],
  },
  {
    label: "CHUB Packing Slip",
    name: "chubPackingSlip",
    key: "chubPackingSlip",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string"],
  },
  {
    label: "Next Action Date",
    name: "nextActionDate",
    key: "nextActionDate",
    disabled: false,
    cb: (date) => extractDate(date),
    fieldType: "date",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "TP Nick Name",
    name: "tpNick",
    key: "tpNick",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string"],
  },
  {
    label: "TP ID",
    name: "tpid",
    key: "tpid",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "numeric"],
    validation: ["string"],
  },
  {
    label: "TP ID Qual",
    name: "tpQualifier",
    key: "tpQualifier",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "numeric"],
    validation: ["string"],
  },
  {
    label: "Alt ID Qual For Drop Only",
    name: "altIdDropOnly",
    key: "altIdDropOnly",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "numeric"],
    validation: ["string"],
  },
  {
    label: "VICS",
    name: "vics",
    key: "vics",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha"],
    validation: ["string"],
  },
  {
    label: "Terms",
    name: "terms",
    key: "terms",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "alpha_space"],
    validation: ["string"],
  },
  {
    label: "Fulfillment Days",
    name: "fullFillmentDays",
    key: "fullFillmentDays",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    validation: ["string", "numeric"],
  },
  {
    label: "Handling Fees",
    name: "handlingFeeAmount",
    key: "handlingFeeAmount",
    disabled: false,
    type: "text",
    fieldType: "text",
    isRequired: "required",
    // validation: ["required", "numeric"],
    validation: ["string"],
  },
  {
    label: "EDI Provider",
    name: "ediProvider",
    key: "ediProvider",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    // validation: ["string", "alpha_num_space"],
    validation: ["string"],
    maxLength: 100,
  },
  {
    label: "Vendor Notes",
    name: "vendorNotes",
    key: "vendorNotes",
    disabled: false,
    fieldType: "text",
    length: 4,
    isRequired: "",
    // validation: ["string", "alpha_num_space"],
    validation: ["string"],
  },
  {
    label: "Integration Instructions",
    name: "integrationInstructions",
    key: "integrationInstructions",
    disabled: false,
    fieldType: "select",
    length: 4,
    isRequired: "",
    validation: ["string"],
    options: [
      {
        label: "Commerce Hub",
        value: "CHUB",
      },
      {
        label: "Direct EDI - Macy's",
        value: "DIRECT_EDI_MCY",
      },
      {
        label: "Direct EDI - BLM",
        value: "DIRECT_EDI_BLM",
      },
      {
        label: "Direct EDI RDS",
        value: "DIRECT_EDI_RDS",
      },
    ],
  },
];

export const vendorPlatformFields = [
  {
    label: "Test SKU's",
    name: "testSku",
    key: "testSku",
    disabled: false,
    maxLength: 75,
    fieldType: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Test PO's",
    name: "testPo",
    key: "testPo",
    disabled: false,
    maxLength: 75,
    fieldType: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Sales Check Number",
    name: "salesCheckNumber",
    key: "salesCheckNumber",
    disabled: false,
    maxLength: 75,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Merge Center",
    name: "mergeCenter",
    key: "mergeCenter",
    disabled: false,
    fieldType: "select",
    isRequired: "",
    options: [
      {
        label: "Santa Fe",
        value: "Santa Fe",
      },
      {
        label: "Highpoint",
        value: "Highpoint",
      },
      {
        label: "North Bergen",
        value: "North Bergen",
      },
      {
        label: "Fedex",
        value: "Fedex",
      },
    ],
  },
];

export const removableFields = [
  "chubAgreementDate",
  "chubIntegrationProfile",
  "chubPackingSlip",
  "altIdDropOnly",
  "vics",
];

export const ownedVendorFields = [
  {
    label: "Vendor Corp Name",
    name: "vendorCorpName",
    key: "vendorCorpName",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Duns #",
    name: "duns",
    key: "duns",
    disabled: true,
    fieldType: "text",
    type: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Dept #",
    name: "dept",
    key: "dept",
    disabled: false,
    fieldType: "select",
    isRequired: "required",
    options: [],
    validation: ["string"],
  },
  {
    label: "Ven #",
    name: "actualVendorNumber",
    key: "actualVendorNumber",
    disabled: true,
    fieldType: "text",
    type: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Operating Division",
    name: "sellingChannel",
    key: "sellingChannel",
    disabled: true,
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Vendor Connection",
    name: "vendorConnectionPlatform",
    key: "vendorConnectionPlatform",
    disabled: false,
    fieldType: "select",
    options: [
      {
        label: "Commerce Hub",
        value: "chub",
      },
      {
        label: "Direct EDI",
        value: "directEdi",
      },
      {
        label: "Direct EDI RDS",
        value: "directEdiRDS",
      },
    ],
    isRequired: "required",
    validation: ["string", "VDF"],
  },
  {
    label: "Target Live Date",
    name: "goLiveTarget",
    key: "goLiveTarget",
    disabled: false,
    fieldType: "date",
    isRequired: "required",
    cb: (date) => extractDate(date),
    validation: ["string"],
  },
  {
    label: "Additional DVN(s)",
    name: "additionalDVN",
    key: "additionalDVN",
    disabled: true,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Product Type",
    name: "productGrp",
    key: "productGrp",
    disabled: false,
    fieldType: "text",
    isRequired: "required",
    validation: ["string"],
    maxLength: 30,
  },
  {
    label: "Annual Sales Volume",
    name: "salesProjections",
    key: "salesProjections",
    disabled: false,
    fieldType: "USDNumber",
    isRequired: "required",
    validation: ["string", "numeric"],
    maxLength: 15,
  },
  {
    label: "Macy's Agreement Date",
    name: "macysAgreementDate",
    key: "macysAgreementDate",
    disabled: false,
    fieldType: "date",
    isRequired: "",
    cb: (date) => extractDate(date),
    validation: ["string"],
  },
  {
    label: "Next Action Date",
    name: "nextActionDate",
    key: "nextActionDate",
    disabled: false,
    cb: (date) => extractDate(date),
    fieldType: "date",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Test SKU's",
    name: "testSku",
    key: "testSku",
    disabled: false,
    maxLength: 75,
    fieldType: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "Test PO's",
    name: "testPo",
    key: "testPo",
    disabled: false,
    maxLength: 75,
    fieldType: "text",
    isRequired: "required",
    validation: ["string"],
  },
  {
    label: "TP Nick Name",
    name: "tpNick",
    key: "tpNick",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "TP ID",
    name: "tpid",
    key: "tpid",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "TP ID Qual",
    name: "tpQualifier",
    key: "tpQualifier",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Alt ID Qual For Drop Only",
    name: "altIdDropOnly",
    key: "altIdDropOnly",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "VICS",
    name: "vics",
    key: "vics",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Terms",
    name: "terms",
    key: "terms",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "Fulfillment Days",
    name: "fullFillmentDays",
    key: "fullFillmentDays",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string", "numeric"],
  },
  {
    label: "Handling Fees",
    name: "handlingFeeAmount",
    key: "handlingFeeAmount",
    disabled: false,
    type: "text",
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
  {
    label: "EDI Provider",
    name: "ediProvider",
    key: "ediProvider",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
    maxLength: 100,
  },
  {
    label: "Vendor Notes",
    name: "vendorNotes",
    key: "vendorNotes",
    disabled: false,
    fieldType: "text",
    isRequired: "",
    validation: ["string"],
  },
];
